import React from "react";
import {Box, Button, IconButton, Stack, TextField, Tooltip, Typography} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {IconX} from "@tabler/icons-react";
import {v4 as uuidv4} from "uuid";

export const InputArgsTab = ({node, setNode, onUpdate}) => {

  const onChangeInputArg = (uid, field, value) => {
    setNode(prev => {
      const state = {...prev};
      if (!state?.data?.input_args) {
        state.data.input_args = [];
      }
      const inputIndex = state.data.input_args.findIndex(input => input.uid === uid);
      if (inputIndex !== -1) {
        state.data.input_args[inputIndex][field] = value;
      }
      return state;
    });
  };

  const onUpdateInputArg = () => {
    onUpdate(node);
  };

  const removeInputArg = (uid) => {
    setNode(prev => {
      const state = {...prev};
      if (state?.data?.input_args) {
        state.data.input_args = state.data.input_args.filter(input => input.uid !== uid);
      }
      return state;
    });
    onUpdate(node);
  };

  const addMessage = () => {
    setNode(prev => {
      const state = {...prev};
      if (!state?.data?.input_args) {
        state.data.input_args = [];
      }
      const newInput = {
        uid: uuidv4(),
        name: "",
        value: ""
      };
      state.data.input_args = [...state.data.input_args, newInput];
      return state;
    });
    onUpdate(node);
  };

  const {primary, secondary} = menuItemsInfo.input_args;

  return (
    <>
      <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
        <Typography fontWeight={700} sx={{pb: 1}}>{primary}</Typography>
        <Typography variant={"body2"} fontSize={13}>{secondary}</Typography>
      </Box>

      {
        node?.data?.input_args?.map((inputArg) => {
          return (
            <Stack direction={"row"} gap={1} key={inputArg.uid} alignItems={"center"} sx={{position: "relative"}}>
              <TextField
                value={inputArg.name}
                size={"small"}
                placeholder={"Input name..."}
                label={"Name"}
                sx={{flex: 1}}
                onChange={e => onChangeInputArg(inputArg.uid, "name", e.target.value)}
                onBlur={() => onUpdateInputArg()}
              />
              <TextField
                value={inputArg.value}
                size={"small"}
                placeholder={"Input value..."}
                label={"Value"}
                sx={{flex: 1}}
                onChange={e => onChangeInputArg(inputArg.uid, "value", e.target.value)}
                onBlur={() => onUpdateInputArg()}
              />
              <Box>
                <Tooltip title={"Delete Input"}>
                  <IconButton
                    sx={{
                      border: 0.5, borderColor: "rgba(48,148,213,0.6)",
                      p: 0.5, color: "info.main", borderRadius: "50% !important",
                    }}
                    onClick={() => removeInputArg(inputArg.uid)}
                  >
                    <IconX size={14} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Stack>
          );
        })
      }

      <Button
        variant={"outlined"}
        color={"secondary"}
        onClick={addMessage}
      >
        Add new Input
      </Button>
    </>
  )
}